<template>
  <div>
    <vs-popup class="product-order-invoice-pdf-popup" id="popup" :title="`${orderCode} INVOICE`" @close="open = false"
      :active.sync="open" :buttons-hidden="true">
      <vx-card no-shadow class="pdf-container">



        <div class="flex items-center justify-center mb-3">
          <vs-button size="small" @click="prevPage" :disabled="currentPage <= 1" class="mr-2">
            Prev
          </vs-button>

          <span class="mx-2">
            Page {{ currentPage }} of {{ numPages || 1 }}
          </span>

          <vs-button size="small" @click="nextPage" :disabled="currentPage >= numPages" class="ml-2">
            Next
          </vs-button>
        </div>

        <div class="pdf-wrapper">
          <pdf v-if="file" :src="file" :page="currentPage" class="pdf-viewer" />
        </div>


        <div class="flex flex-wrap items-center justify-end mt-4">
          <vs-button @click="onClickDownload" button="submit" icon-pack="feather" icon="icon-download-cloud"
            color="primary" class="ml-auto mt-2">
            Download
          </vs-button>
          <vs-button v-if="statusName !== 'Cancelled'" @click.stop="generateReportPromtActive()" button="submit"
            icon-pack="feather" icon="icon-send" color="warning" class="ml-2 mt-2">{{ isSentEmail ? "Resend Invoice" :
      "Send Invoice" }}</vs-button>
        </div>
      </vx-card>
    </vs-popup>
    <vs-prompt @cancel="customer_email = []" @accept="onClickSendEmail" @close="activePrompt = false"
      :title="'Select customer user email to send'" :accept-text="'Confirm'" :color="'primary'"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <span>Select user email</span>
        <v-select class="invoice-email-select" :clearable="true" name="customerId" placeholder="" v-model="customer_email" label="email"
          multiple :options="customer_list" :reduce="(option) => option.email" :dir="$vs.rtl ? 'rtl' : 'ltr'">
          <template v-slot:option="option">
            <span>{{ option.email }} ( {{ option.job_title || "N/A" }} ) </span>
          </template>
        </v-select>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import pdf from "vue-pdf";
import { RepositoryFactory } from "@/repository/RepositoryFactory";
const CustomerRepository = RepositoryFactory.get("customer");
const DropDownRepository = RepositoryFactory.get("drop_down");
import vSelect from "vue-select";
import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from "@/mixins/ErrorMessages";

function initialState() {
  return {
    open: false,
    id: "",
    file: "",
    numPages: 0,
    currentPage: 1,
    customer_id: "",
    orderCode: "",
    isSentEmail: false,
    statusName: "",
    customer_email: [],
    customerId: "",
    customer_list: [],
    activePrompt: false,
    numPages: 0,
  };
}

export default {
  name: "SalesQuotePrintView",
  data() {
    return initialState();
  },
  methods: {
    async onClickDownload() {
      window.open(this.file);
    },
    async openPopup(id, order_code, status, is_sent_email, customer_id) {
      try {
        await Object.assign(this.$data, initialState());
        this.id = id;
        this.orderCode = order_code;
        this.isSentEmail = is_sent_email;
        this.statusName = status;
        this.customerId = customer_id;
        await this.getInvoicePdf();
        this.open = true;
      } catch (error) {
        //
      }
    },
    async getInvoicePdf() {
      this.$vs.loading();
      try {
        CustomerRepository.getSalesInvoicePdf(this.id).then((response) => {
          const file = new Blob([response.data], { type: "application/pdf" });
          this.file = URL.createObjectURL(file)
          this.currentPage = 1

          pdf.createLoadingTask(this.file).promise.then((pdfDoc) => {
            this.numPages = pdfDoc.numPages
          })

          this.open = true
          this.$vs.loading.close();
        });
      } catch (e) {
        this.$vs.loading.close();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.numPages) {
        this.currentPage++;
      }
    },
    handleKeyNav(e) {
      if (!this.open) return;
      if (e.key === "ArrowRight") this.nextPage()
      if (e.key === "ArrowLeft") this.prevPage()
    },
    async generateReportPromtActive() {
      try {
        const { data } = (
          await DropDownRepository.getCustomerUsersDropdownList(this.customerId)
        ).data;
        this.customer_list = data;
        this.open = false;
        this.activePrompt = true;
      } catch (e) { }
    },
    async onClickSendEmail() {
      this.activePrompt = false;
      this.$vs.loading();
      try {
        if (this.isSentEmail) {
          await CustomerRepository.invoiceResendCustomer(this.id, {
            user_email: this.customer_email,
          });
        } else {
          await CustomerRepository.invoiceSentCustomer(this.id, {
            user_email: this.customer_email,
          });
        }
        this.$emit("refreshData");
        this.showSuccessMessage("Invoice sent successfully");
      } catch (e) {
        this.convertAndNotifyError(e);
      }

      this.$vs.loading.close();
    },
  },
  components: {
    pdf,
    "v-select": vSelect,
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeyNav)
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeyNav)
  },
  mixins: [SuccessMessage, ErrorMessages],
};
</script>

<style>
.invoice-email-select .vs__search {
  width: 100%;
}
</style>

<style scoped>
.product-order-invoice-pdf-popup>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 40% !important;
}

.pdf-container {
  display: flex;
  flex-direction: column;
  height: 80vh;
}

.pdf-wrapper {
  flex: 1;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 8px;
}

.pdf-viewer {
  width: 100%;
  height: 100%;
  max-height: 100%;
  object-fit: contain;
}
</style>
